import { useQuery } from "@tanstack/react-query";

import { pinnedJobsQueryKey } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, PinnedJobResponse } from "@/types";

export function useGetPinnedJobs() {
  return useQuery({
    queryKey: pinnedJobsQueryKey,
    queryFn: async () => {
      const path = "job-users/pinned-jobs";
      const res = await guacHttpClient.get<
        PinnedJobResponse[],
        HttpResponse<PinnedJobResponse[]>
      >(path);
      return res.data;
    },
  });
}
